import type { PanelMemberRole } from "../../../../../types/panel.type";

export const getRoleBadgeClasses = (role: PanelMemberRole): string => {
	switch (role) {
		case "rfxLead":
			return "bg-purple-100 text-purple-700";
		case "member":
			return "bg-gray-100 text-gray-700";
		case "observer":
			return "bg-amber-50 text-amber-600";
		default:
			return "bg-gray-100 text-gray-700";
	}
};

export const formatMemberDate = (dateStr: string | null): string => {
	if (!dateStr) {
		return "—";
	}
	const date = new Date(dateStr);
	return date.toLocaleDateString("en-AU", {
		day: "2-digit",
		month: "short",
		year: "numeric",
	});
};
